import * as React from 'react';
import * as ROUTES from '../../../router/Routes';
import ContainerTemplate from '../../../widgets/template/Container';
import EntHorarioClasesView from '../../entidad/ent_horario_clases/ent_horario_clases/EntHorarioClasesView';

const HorariosModule = () => {
  return (
    <ContainerTemplate
      active={ROUTES.horarios}
      routes={[ROUTES.controlEstudios]}
    >
      <EntHorarioClasesView />
    </ContainerTemplate>
  );
};

export default HorariosModule;
